<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
      <v-tab ripple :key="'upload-user'" :href="'#uploaduser'"> Upload User </v-tab>
      <v-tab ripple :key="'target'" :href="'#target'"> Target </v-tab>
    </v-tabs>
    <UploadUser v-if="currentView == 'uploaduser'" />
    <Target v-else-if="currentView == 'target'" />
  </div>
</template>

<script>
import UploadUser from './uploadUser'
import Target from './target'

export default {
  components: {
    UploadUser,
    Target
  },
  data() {
    return {
      currentView: 'uploaduser'
    }
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/centralhr/main.vue